import { useContext, useEffect, useState } from 'react';
import DynamicDownloadBtnSection from '../../../../components/DynamicDownloadBtnSection/DynamicDownloadBtnSection';
import "./Minutes.scss";
import { AppContext } from '../../../../context/AppContext';
import axios from 'axios';
import { toast } from 'react-toastify';

const Minutes = () => {
    const { backendUrl } = useContext(AppContext);
    const [allMinutesReports, setAllMinutesReports] = useState([]);
     let errorShown = false;

      async function fetchAllMinutesReports() {
        try {
            const { data } = await axios.get(`${backendUrl}/api/auth/getAllMinutes`);
            if (data.success) {
                setAllMinutesReports(data || []);
            } 
            errorShown = false;  
        } catch (error) {
            if (errorShown) return;
            errorShown = true;
            if (error.response && error.response.status === 503) {
                            toast.error("⚠️ The service is currently under maintenance. Please try again later.");
                        }
                        else if (!navigator.onLine) {
                            toast.error("🚫 No internet connection. Please check your network.");
                        }
            
                        else if (error.request && !error.response) {
                            toast.error("⚠️ Network issue or server is unreachable. Try again later.")
                        }
                        else 
                        {
                            console.error("Unexpected error:", error);
                            toast.error("Something went wrong.");
                        }
        }
    }

    useEffect(() => {
        fetchAllMinutesReports();
    }, []);

    const content = allMinutesReports?.reports
        ?.filter(item => item.isActive)
        .map(item => ({
            filename: item.filename,
            data: item.data,
            contentType: item.contentType,
        })) || [];

    return (
        <section className="minutesMainContainer">
            <header className="minutesHeader">
                <h2>Minutes</h2>
            </header>
            <DynamicDownloadBtnSection
                items={content}
                yearFontSize={1.25}
            />
        </section>
    )
}

export default Minutes;
